module.exports = __webpack_public_path__ + "static/media/6.46bb31a0.jpg";